<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <CosttypeForm :formProps="formProps">
                </CosttypeForm>
            </template>
            <template #search="searchProps">
                <CosttypeSearch :searchProps="searchProps">
                </CosttypeSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import CosttypeForm from './CosttypeForm.vue'
import CosttypeSearch from './CosttypeSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { ref } from "vue";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
